<template>
    <card :item="item" :type="type">
        <div class="cardbody color6" @click.stop="goDetails(item)">
            <div class="header">
                <div class="header-title color3">
                    <div class="item_lt single_hide color3">
                        {{ item.categoryName.split("-").length>=3 ? item.categoryName.split("-")[2] : item.categoryName.split("-")[ item.categoryName.split("-").length-1] }}
                    </div>
                </div>
            </div>
            <div style="display:flex;padding-left:10px;font-size:14px">
                <div style="width:300px">
                    <div style="margin-top:12px" class="color0">报价方案</div>
                    <div style="margin-top:12px" class="color6" v-for="(item,index) in item.schemeList" :key="index">
                        {{item.name}}
                    </div>
                </div>
                <div style="width:300px">
                    <div style="margin-top:12px" class="color0">计量单位</div>
                    <div style="margin-top:12px" class="color6" v-for="(item,index) in item.schemeList" :key="index">
                        {{item.unit}}
                    </div>
                </div>
                <div style="width:200px">
                    <div style="margin-top:12px" class="color0">单价(元)</div>
                    <div style="margin-top:12px" class="color6" v-for="(item,index) in item.schemeList" :key="index">
                        {{item.unitPrice}}
                    </div>
                </div>
            </div>
            <div class="address">
                <img src="@/assets/team/locationIcon.png" />
                <span style="color: #666666; margin-left: 5px">{{ item.location ? item.location : "-" }}</span>
                <span v-if="item.updateTime===item.createTime" class="createTime color6">{{item.createTime | formatDate}}发布</span>
                <span v-else class="createTime color6">{{item.updateTime | formatDate}}更新</span>
            </div>
        </div>
    </card>
</template>

<script>
import {checkDataStatusMessage} from "@/utils/checkDataStatus";

export default {
    name: "cardVolunteerTeamOffer",
    components: {
        card: () => import("@/components/card/card")
    },
    inject:['cardListCom'],
    props: {
        item: Object,
        type: Number, // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    },
    mounted(){
        this.$nextTick(() => {
        //处理2.1.4之前得老数据
            if(this.item.schemeList&&!this.item.schemeList.length){
                if(this.item.hasMaterial==0){
                    this.item.hasMaterial='包含辅材'
                }else if(this.item.hasMaterial==1){
                    this.item.hasMaterial='包含机械设备'

                }else if(this.item.hasMaterial==2){
                    this.item.hasMaterial='包含辅材和机械设备'

                }else if(this.item.hasMaterial==3){
                    this.item.hasMaterial='不包含辅材和机械设备'
                }
                this.item.schemeList=[{name:`${this.item.hasMaterial}`,unit:`${this.item.unit}`,unitPrice:`${this.item.price}`}]
            } 
            if(this.item.schemeList.length>2){
                this.item.schemeList= this.item.schemeList.slice(0,2)
            }
        });
    },
    methods: {
        //跳转详细
        async goDetails({ companyNo, userNo, no }) {
          let type=await checkDataStatusMessage.call(this,this.type,no);
          if(type!=1){return;}
            let query = { pNo: no }
            let path = ""
            if ((companyNo && companyNo !== 0) || (companyNo && userNo)) {
                path = "/TeamOfferDetail"
                query.companyNo = companyNo
            } else if (userNo) {
                path = "/IndividualTeamOfferDetail"
                query.userNo = userNo
            }
            let routeUrlC = `${((companyNo && companyNo !== 0) || (companyNo && userNo))?"/TeamOfferDetail":"/IndividualTeamOfferDetail"}?companyNo=${companyNo}&userNo=${userNo}&pNo=${no}`
            window.open(routeUrlC, "_blank")
            /*this.$router.push({ path, query })*/
        }
    },
}
</script>
<style lang="scss" scoped>
.cardbody {
    position: relative;
    cursor: pointer;
    min-height: 170px;
    .header {
        padding: 0px 10px;
        background: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
        .header-title {
            font-size: 16px;
            height: 34px;
            line-height: 34px;
            .item_lt {
                max-width: 360px;
                margin-right: 15px;
                font-size: 16px;
            }
        }
    }
}
.address {
    border-top: 1px dashed #e4e7ed;
    padding-left: 10px;
    width: 100%;
    height: 34px;
    line-height: 34px;
    position: absolute;
    bottom:0px;
    left: 0px;
    img {
        vertical-align: middle;
        margin-top: -4px;
    }
     .createTime{
        position: absolute;
        right: 15px;
    }
}
.single_hide {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
div {
    box-sizing: border-box;
}
.color6 {
    color: #666666;
}
.color3 {
    color: #333333;
}
.color0 {
    color: #000;
}
</style>
